import React from 'react';

/**
 * A simple "Back to Home" link used at the top and bottom of legal / info pages.
 * Self-contained (own centered container) so it can drop straight after the nav
 * or just before a page's closing wrapper.
 */
export const BackToHome = ({ maxWidth = 820, style, testid = 'back-to-home-link' }) => (
  <div style={{ maxWidth, margin: '0 auto', padding: '1.25rem 2rem', ...style }}>
    <a
      href="/"
      data-testid={testid}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '0.45rem',
        color: '#0076A3',
        fontSize: '0.875rem',
        fontWeight: 600,
        textDecoration: 'none',
      }}
    >
      <span aria-hidden="true">&larr;</span> Back to Home
    </a>
  </div>
);

export default BackToHome;
